import { render, staticRenderFns } from "./vehicle-choice-model.vue?vue&type=template&id=6a9ffa46&scoped=true"
import script from "./vehicle-choice-model.vue?vue&type=script&lang=js"
export * from "./vehicle-choice-model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ffa46",
  null
  
)

export default component.exports